const PATH = 'fe.components.login_manager.login_with_code.verify_code_form';

const messages = {
  fields: {
    phone: {
      key: `${PATH}.fields.phone`,
      defaultValue: 'Phone Number'
    },
    code: {
      key: `${PATH}.fields.code`,
      defaultValue: '6-Digit Code'
    },
    codePlaceholder: {
      key: `${PATH}.fields.code_placeholder`,
      defaultValue: 'Enter 6-Digit Code'
    }
  },
  errors: {
    code: {
      required: {
        key: `${PATH}.errors.code.required`,
        defaultValue: 'Enter the 6-digit code sent to your mobile phone'
      }
    }
  },
  submit: {
    key: `${PATH}.submit`,
    defaultValue: 'Submit Code'
  },
  resend: {
    key: `${PATH}.resend`,
    defaultValue: 'Resend Code'
  },
  resendCountdown: {
    key: `${PATH}.resend_countdown`,
    defaultValue: 'Resend Code ({{seconds}}s)'
  },
  codeSentTo: {
    key: `${PATH}.code_sent_to`,
    defaultValue: 'We texted a code to {{phone}}.'
  },
  codeSent: {
    key: `${PATH}.code_sent`,
    defaultValue:
      'A new code has been sent. Only the most recent code will work.'
  },
  codeSentHint: {
    key: `${PATH}.code_sent_hint`,
    defaultValue: 'We texted a code to this number.'
  }
};

export default messages;
